/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Transit Direction of asset travel or location if its not moving.
 */
export var AssetTransitDirection;
(function (AssetTransitDirection) {
    AssetTransitDirection["AT_SITE"] = "AtSite";
    AssetTransitDirection["AT_SOURCE"] = "AtSource";
    AssetTransitDirection["TOWARDS_SOURCE"] = "TowardsSource";
    AssetTransitDirection["TOWARDS_SITE"] = "TowardsSite";
})(AssetTransitDirection || (AssetTransitDirection = {}));
